import { createFileRoute, redirect } from '@tanstack/react-router';

import { meQuery } from '../../api/hooks';
import { isStaff } from '../../lib/roles';
import { Notifications } from './notifications';

// What the console noticed across every organization, and what belongs to none: staff's inbox.
export const Route = createFileRoute('/_app/inbox')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.fetchQuery(meQuery);
    if (!me || !isStaff(me)) throw redirect({ to: '/overview', search: {} });
  },
  component: Notifications,
});
